import { createReducer, createNamespacer } from '../commons/js/utils/reducer';

const namespacers = {
    printLabels: createNamespacer("PRINT_LABELS"),
}

const initialstate = { 
    disableDropdown: {},
    updatedPackages: [],
    labelsData: [],
    showLabels: false,
    pipesPdfUrl: '',
}

const welcomeUserReducer = createReducer(initialstate, {
    [namespacers.printLabels("SET_ENABLE")]: (state, action) => {
        let enableItems = [...state.updatedPackages]

        let packages = enableItems.map((element) => {
            if(element.id === action.payload.value) {
                return {
                    ...element,
                    'checked': false,
                    'radioChecked':true,
                }
            } else {
                return {
                    ...element,
                    'checked': true,
                    'radioChecked' : false,
                }
            }
        })

        return {
            ...state,
            updatedPackages: packages,
        }
    },

    [namespacers.printLabels("SET_NEW_PACKAGES")]: (state, action) => {
        return{
            ...state,
            updatedPackages: action.payload.value
        }
    },
    "SET_LABELS_PDF_URL" : (state, action) => {
        return {
            ...state,
            pipesPdfUrl: action.payload.value,
        }
    },

    [namespacers.printLabels("SET_LABELS_DATA_CHECK")]: (state, action) => {
        return{
            ...state,
            showLabels: action.payload.value,
        }
    },

    [namespacers.printLabels("SET_PRINT_LABELS")]: (state, action) => {
        return{
            ...state,
            labelsData: action.payload.value
        }
    },

})

export default welcomeUserReducer;